export default __webpack_public_path__ + "static/media/gallery_07.d3adcbf2.jpg";